import { ClickOutsideDirective } from './unavailability/click-outside.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleComponent } from './schedule.component';
import { UnavailabilityComponent } from './unavailability/unavailability.component';
import { ScheduleRoutingModule } from './schedule-routing.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FeatureModule } from '../../../../shared/src/lib/feature/feature.module';
import { DailyModule } from './daily/daily.module';
import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'ngx-moment';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AvailabilityCalendarComponent } from './recurring-availibility/availability-calendar/availability-calendar.component';
import { PonctualAvailibilityComponent } from './ponctual-availibility/ponctual-availibility.component';
import { RecurringAvailibilityComponent } from './recurring-availibility/recurring-availibility.component';
import { PonctualCalendarComponent } from './ponctual-availibility/ponctual-calendar/ponctual-calendar.component';
import { DirectiveModule } from '../../../../shared/src/lib/directive/directive.module';
import { FormsModule } from '@angular/forms';
@NgModule({
  imports: [
    CommonModule,
    ScheduleRoutingModule,
    MatSelectModule,
    DailyModule,
    MomentModule,
    FeatureModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    TranslateModule.forChild(),
    DirectiveModule,
    FormsModule,
    FullCalendarModule,
  ],
  declarations: [
    ScheduleComponent,
    AvailabilityCalendarComponent,
    UnavailabilityComponent,
    ClickOutsideDirective,
    PonctualAvailibilityComponent,
    PonctualCalendarComponent,
    RecurringAvailibilityComponent,
  ],
})
export class ScheduleModule { }